<template>
  <b-col class="sticky-element__container">
    <loader watch="deviceGuardProbes">
      <b-row>
        <b-button
          variant="link"
          class="sticky-element__edit"
          @click="editGuardTableVisibility = !editGuardTableVisibility"
        >
          <Icon name="edit" />
        </b-button>
      </b-row>
      <b-col v-if="guardProbes" no-gutters class="scrollable-wrapper">
        <b-col class="table" :class="{ 'table--opened': isOpen }">
          <b-row class="table__header">
            <b-col v-for="voltageColumnName in voltageProbesColumns" :key="voltageColumnName">
              {{ voltageColumnName }}
            </b-col>
          </b-row>
          <b-row
            v-for="(voltageValues, voltageIndex) in parseForNulls(guardProbes.voltageProbes)"
            :key="`${voltageValues.connectionPoint}${voltageIndex}`"
            class="table__cell"
            data-test="voltage-probes-row"
          >
            <b-col>{{ voltageIndex + 1 }}</b-col>
            <b-col>{{ voltageValues[0] }}</b-col>
            <b-col>{{ voltageValues[1] }}</b-col>
          </b-row>
          <b-row class="my-2" />
          <b-row class="table__header">
            <b-col v-for="currentColumnName in currentProbesColumns" :key="currentColumnName">
              {{ currentColumnName }}
            </b-col>
          </b-row>
          <b-row
            v-for="(currentValues, currentIndex) in parseForNulls(guardProbes.currentProbes)"
            :key="`${currentValues.feederName}${currentValues.phase}${currentIndex}`"
            class="table__cell"
            data-test="current-probes-row"
          >
            <b-col>{{ currentIndex + 1 }}</b-col>
            <b-col
              v-for="(value, currentValueIndex) in currentValues"
              :key="`${value}${currentValueIndex}`"
            >
              {{ value }}
            </b-col>
          </b-row>
        </b-col>
      </b-col>
      <b-button
        v-if="guardProbes"
        variant="link"
        class="sticky-element__collapse"
        @click="isOpen = !isOpen"
      >
        <span class="circle">
          <Icon v-if="isOpen" name="chevron-up" />
          <Icon v-else name="chevron-down" />
        </span>
      </b-button>
      <b-modal v-model="editGuardTableVisibility" hide-footer>
        <EditGuardTableForm
          :guard-probes="{
            voltageProbes: guardProbes.voltageProbes,
            currentProbes: guardProbes.currentProbes
          }"
          @submit="submit"
          @hide="editGuardTableVisibility = !editGuardTableVisibility"
        />
      </b-modal>
    </loader>
  </b-col>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import EditGuardTableForm from '@/components/shared/edit-guard-table-form';
import {
  VOLTAGE_COLUMNS_NAMES,
  CURRENT_COLUMNS_NAMES
} from '@/components/shared/device-events-consts';

const NOT_PRESENT = '-';
const NOT_USED = 'Not Used';
const MAPPER_VALUES = {
  FEEDER_NAME: 'feederName',
  PHASE: 'phase',
  CONNECTION_POINT: 'connectionPoint'
};

const mapper = (key, valueToMap) => {
  switch (key) {
    case MAPPER_VALUES.FEEDER_NAME || MAPPER_VALUES.CONNECTION_POINT:
      return valueToMap || NOT_PRESENT;
    case MAPPER_VALUES.PHASE:
      if (valueToMap === null) return NOT_USED;

      return valueToMap ? `L${Number(valueToMap)}` : 'N';
    default:
      return valueToMap || NOT_PRESENT;
  }
};

export default {
  name: 'GuardTable',
  components: { EditGuardTableForm },
  data() {
    return {
      editGuardTableVisibility: false,
      voltageProbesColumns: VOLTAGE_COLUMNS_NAMES,
      currentProbesColumns: CURRENT_COLUMNS_NAMES,
      isOpen: false
    };
  },
  computed: mapState({
    guardProbes: state => state.guard1000Probes.data
  }),
  mounted() {
    const { projectCode, substationCode, externalGuardId } = this.$route.params;

    this.fetchData({
      projectCode,
      substationCode,
      externalGuardId
    });
  },
  beforeDestroy() {
    this.resetStore();
  },
  methods: {
    ...mapActions({
      fetchData: 'guard1000Probes/fetchData',
      editGuardProbe: 'guard1000Probes/editGuardProbe'
    }),
    ...mapMutations({
      resetStore: 'guard1000Probes/resetStore'
    }),
    submit(guardForm) {
      this.editGuardTableVisibility = false;

      const { projectCode, substationCode, externalGuardId } = this.$route.params;

      const response = this.editGuardProbe({
        projectCode,
        substationCode,
        externalGuardId,
        guardForm
      });

      if (response === 200) {
        this.fetchData({
          projectCode,
          substationCode,
          externalGuardId
        });
      }
    },
    parseForNulls(objectToParse = {}) {
      return Object.keys(objectToParse).map(shallowNestIndex =>
        Object.keys(objectToParse[shallowNestIndex]).map(deepNestIndex =>
          mapper(deepNestIndex, objectToParse[shallowNestIndex][deepNestIndex])
        )
      );
    }
  }
};
</script>
